import { EditorLocation } from '../models/editor-location.model';

export function formatAddress(location: EditorLocation): string {
    return [
        [
            location.name,
            location.streetAddress,
            location.city,
            location.region,
        ]
            .filter((value) => !!value)
            .join(', '),
        location.postalCode,
        location.countryName,
    ]
        .filter((value) => !!value)
        .join(' ');
}
